import React from 'react';
import { FileText } from 'lucide-react';

const AlgemeneVoorwaarden = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex justify-center mb-4">
              <FileText className="w-16 h-16" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Algemene Voorwaarden
            </h1>
            <p className="text-xl text-blue-100">
              Nikita's Reizen op Maat (Bemiddeling)
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">

            {/* Section 1 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">1. Algemeen</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Deze algemene voorwaarden zijn van toepassing op alle offertes, boekingen en overeenkomsten van Nikita's Reizen op Maat.</li>
                <li>Nikita's Reizen op Maat treedt uitsluitend op als bemiddelaar bij het tot stand brengen van reisovereenkomsten tussen de klant en externe dienstverleners, zoals luchtvaartmaatschappijen, accommodaties en lokale partners.</li>
                <li>De overeenkomst voor de reis komt tot stand tussen de klant en de betreffende leverancier(s).</li>
                <li>Door akkoord te gaan met een offerte verklaart de klant zich akkoord met deze voorwaarden.</li>
              </ul>
            </div>

            {/* Section 2 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">2. Offertes</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Alle offertes zijn vrijblijvend en geldig tot de vermelde vervaldatum.</li>
                <li>Prijzen en beschikbaarheid zijn afhankelijk van externe leveranciers en kunnen wijzigen totdat de boeking definitief is gemaakt.</li>
                <li>Kennelijke fouten of vergissingen binden Nikita's Reizen op Maat niet.</li>
              </ul>
            </div>

            {/* Section 3 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">3. Totstandkoming van de boeking</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Een boeking komt tot stand zodra de klant:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-3">
                <li>schriftelijk akkoord geeft (e-mail/WhatsApp), en/of</li>
                <li>een betaling verricht.</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-3">
                Na akkoord is de boeking definitief.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Nikita's Reizen op Maat bemiddelt bij het tot stand brengen van afzonderlijke overeenkomsten tussen de klant en de betreffende leveranciers.
              </p>
              <p className="text-gray-700 leading-relaxed">
                De aangeboden reisonderdelen vormen geen pakketreis in de zin van de Richtlijn Pakketreizen.
              </p>
            </div>

            {/* Section 4 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">4. Betaling</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                De volledige reissom dient in één keer te worden voldaan bij bevestiging van de boeking.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Na akkoord ontvangt de klant een factuur met het totale bedrag. Betaling dient te geschieden binnen de op de factuur vermelde termijn.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                De boeking wordt pas in behandeling genomen en definitief vastgelegd na ontvangst van de volledige betaling.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Indien betaling niet tijdig plaatsvindt, behoudt Nikita's Reizen op Maat zich het recht voor om:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-3">
                <li>de reservering te annuleren, en/of</li>
                <li>eventuele kosten van leveranciers door te berekenen.</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Alle gevolgen van niet tijdige betaling zijn voor rekening van de klant.
              </p>
            </div>

            {/* Section 5 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">5. Prijzen en kosten</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Alle prijzen zijn gebaseerd op tarieven van externe leveranciers.</li>
                <li>Eventuele prijswijzigingen vanuit leveranciers (zoals brandstoftoeslagen, belastingen of wisselkoersen) kunnen worden doorberekend.</li>
                <li>Nikita's Reizen op Maat kan daarnaast een servicevergoeding rekenen voor haar dienstverlening. Deze wordt vooraf duidelijk gecommuniceerd.</li>
              </ul>
            </div>

            {/* Section 6 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">6. Annulering door de klant</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Bij annulering gelden de voorwaarden van de betreffende leverancier(s).</li>
                <li>In de meeste gevallen kunnen annuleringskosten oplopen van 30% tot 100% van de reissom.</li>
                <li>Eventuele niet-restitueerbare kosten worden volledig doorberekend aan de klant.</li>
              </ul>
            </div>

            {/* Section 7 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">7. Wijzigingen</h2>
              <p className="text-gray-700 leading-relaxed">
                Wijzigingen na bevestiging zijn afhankelijk van de voorwaarden van de betreffende leverancier(s). Eventuele kosten die hieruit voortvloeien worden volledig doorberekend aan de klant.
              </p>
            </div>

            {/* Section 8 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">8. Aansprakelijkheid</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Nikita's Reizen op Maat is niet verantwoordelijk voor de uitvoering van de reis. De verantwoordelijkheid voor de uitvoering ligt volledig bij de betreffende leverancier(s).
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Nikita's Reizen op Maat is niet aansprakelijk voor:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-3">
                <li>vertragingen of annuleringen</li>
                <li>verlies, schade of letsel</li>
                <li>wijzigingen door derden</li>
                <li>overmacht (zoals natuurrampen, stakingen of pandemieën)</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                De aansprakelijkheid van Nikita's Reizen op Maat is in alle gevallen beperkt tot het bedrag van de ontvangen servicevergoeding. Om eventuele problemen te voorkomen sluit dan zelf een reis- en/of annuleringsverzekering af.
              </p>
            </div>

            {/* Section 9 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">9. Reispapieren en verplichtingen</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                De klant is zelf verantwoordelijk voor:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-3">
                <li>geldige reisdocumenten</li>
                <li>visa</li>
                <li>vaccinaties</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Nikita's Reizen op Maat kan hierin adviseren, maar is niet aansprakelijk voor gevolgen bij het niet voldoen aan deze verplichtingen.
              </p>
            </div>

            {/* Section 10 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">10. Verzekeringen</h2>
              <p className="text-gray-700 leading-relaxed">
                Het afsluiten van een reis- en annuleringsverzekering wordt sterk aanbevolen. De klant is hier zelf verantwoordelijk voor.
              </p>
            </div>

            {/* Section 11 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">11. Klachten</h2>
              <p className="text-gray-700 leading-relaxed">
                Klachten dienen direct tijdens de reis gemeld te worden bij de betreffende leverancier. Indien dit niet mogelijk is, dient de klacht zo spoedig mogelijk schriftelijk gemeld te worden bij Nikita's Reizen op Maat.
              </p>
            </div>

            {/* Section 12 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">12. Geen herroepingsrecht</h2>
              <p className="text-gray-700 leading-relaxed">
                Op reisgerelateerde diensten is geen herroepingsrecht van toepassing. Boekingen zijn na bevestiging definitief.
              </p>
            </div>

            {/* Section 13 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">13. Privacy</h2>
              <p className="text-gray-700 leading-relaxed">
                Persoonsgegevens worden uitsluitend gebruikt voor het uitvoeren van de boeking en gedeeld met betrokken leveranciers.
              </p>
            </div>

            {/* Section 14 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">14. Toepasselijk recht</h2>
              <p className="text-gray-700 leading-relaxed">
                Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.
              </p>
            </div>

            {/* Section 15 - Bedrijfsgegevens */}
            <div className="mt-12 p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border border-blue-200">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">15. Bedrijfsgegevens</h2>
              <div className="space-y-2 text-gray-700">
                <p className="font-semibold text-blue-900">Nikita's Reizen op Maat</p>
                <p>📧 Nikitasopmaatreizen@outlook.com</p>
                <p>📱 06 243 597 64</p>
                <p>KvK: 42050105</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AlgemeneVoorwaarden;
